import { BLOCKS, INLINES, type Document as RichTextDocument } from '@contentful/rich-text-types'

export const faqData = [
  {
    question: `What does data privacy management software do?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Data privacy management software helps businesses automate and enforce certain controls or settings to protect sensitive data and stay compliant with privacy laws and regulations.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `These tools can help keep an updated inventory of data to know which information is stored where, who has access, and any transformations the data has undergone. It can also help regulate internal access to sensitive or high-risk data (like personally identifiable information) and encrypt data for further protection.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `What features should I look for in a privacy management tool?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `The needs and requirements of a privacy management tool will depend on your business, but a few common things to look for include:`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `Data encryption abilities`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `Permission and user controls to prevent unauthorized access`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `Integration capabilities`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `User rights management (e.g., handle requests for data deletion)`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
          ],
          data: {},
          nodeType: BLOCKS.UL_LIST,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `How do companies manage data privacy?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Managing data privacy requires a clear set of policies and procedures. It begins with documenting what data your business collects, why you’re collecting it, who has access to it, and where it ultimately will be stored. From there, businesses can begin to classify data based on risk level, manage who has access internally, and enforce different security measures like encryption at rest and in transit.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Managing data privacy also requires having a clear understanding of overarching data privacy laws and regulations that apply to your business. Many businesses also appoint a `,
            },
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Data Protection Officer`,
                },
              ],
              data: {
                uri: `https://segment.com/resources/data-privacy/what-is-a-data-protection-officer/`,
              },
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: ` to help oversee these efforts.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Data privacy tools are especially helpful for managing data privacy at scale, as they’re able to automate auditing, risk detection, and more.`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
  {
    question: `What does Privacy Portal from Segment do?`,
    answer: {
      content: [
        {
          content: [
            {
              data: {},
              marks: [],
              nodeType: `text`,
              value: `Segment’s Privacy Portal automates data governance at scale so businesses can protect customer data and stay compliant with laws and regulations like the GDPR and CCPA. A few key features to Segment’s Privacy Portal include:`,
            },
          ],
          data: {},
          nodeType: BLOCKS.PARAGRAPH,
        },
        {
          content: [
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `The ability to automatically detect and classify sensitive or high-risk data (e.g., PII)`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `Proactively block data that doesn’t adhere to your company’s tracking plan`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `PManage user deletion or suppression requests at scale`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `Data encryption at rest and in transit`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `An `,
                    },
                    {
                      content: [
                        {
                          data: {},
                          marks: [],
                          nodeType: `text`,
                          value: `open-source consent manager`,
                        },
                      ],
                      data: {
                        uri: `https://segment.com/blog/how-to-build-consent-management-into-your-site-in-less-than-a-week/`,
                      },
                      nodeType: INLINES.HYPERLINK,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
            {
              content: [
                {
                  content: [
                    {
                      data: {},
                      marks: [],
                      nodeType: `text`,
                      value: `And more!`,
                    },
                  ],
                  data: {},
                  nodeType: BLOCKS.PARAGRAPH,
                },
              ],
              data: {},
              nodeType: BLOCKS.LIST_ITEM,
            },
          ],
          data: {},
          nodeType: BLOCKS.UL_LIST,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    } as RichTextDocument,
  },
]
